module.exports = __webpack_public_path__ + "static/media/imparta.a3ffa1ce.png";